import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=23cc3e93&scoped=true&"
import script from "./ChangePassword.js?vue&type=script&lang=js&"
export * from "./ChangePassword.js?vue&type=script&lang=js&"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=23cc3e93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cc3e93",
  null
  
)

export default component.exports